import React, { useEffect , useState } from 'react';
import { useTranslation } from 'react-i18next'
import './login.scss'
import { handleSignin } from '../../actions'
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button, Typography , notification , Spin } from 'antd';
import LoginService from '../../services/loginService';
import { updateUserWithFirebaseToken } from 'firebase/messaging_init_in_sw';
import { useLocation } from 'react-router-dom';

function Login(props) {
    const { t: translation } = useTranslation()
    const { history } = props
    const user = useSelector((state) => state.member)
    const [isLoading , setIsLoading] = useState(false);
    const { isUserLoggedIn, permissions, appUserRoleId } = user
    const location = useLocation();
    const dispatch = useDispatch()

    useEffect(() => {
        if (user && isUserLoggedIn) {
            // history.push("/");
            const searchParams = new URLSearchParams(location.search);
            const redirectUrl = searchParams.get("redirect") || "/";
            history.replace(redirectUrl); // quay về đúng link trước khi login
        }
    }, [])

    const onFinish = (values) => {
        setIsLoading(true);
        LoginService.Signin(values).then(async (result) => {
            if (!result.isSuccess) {
                const translatedError = translation(`landing.loginError.${result.error}`);
                const errorMessage = (translatedError && !translatedError.includes('landing.')) ? translatedError : translation('landing.loginFail');
                notification['error']({
                    message: '',
                    description: errorMessage
                })
                setIsLoading(false);
                return
            }

            const data = result.data;
            if (data && data.appUserId) {
                if (data.twoFAEnable === 1) {
                    history.push('/verifying-user', data)
                } else {
                    const token = await updateUserWithFirebaseToken(data , translation);
                    dispatch(handleSignin({
                        ...data , 
                        firebaseToken : token
                    }))
                    //truyền token lên param để xử lý lần đầu sau khi login
                    const searchParams = new URLSearchParams(location.search);
                    const redirectUrl = searchParams.get("redirect") || "/";
                    history.push(`/login-success?token=${data.token}&redirect=${encodeURIComponent(redirectUrl)}`);
                }
            }
            setIsLoading(false);
        })
    }

    if(isLoading) {
      return (<Spin />)
    }

    return (
        <main className="login">
            <div className="login_form__title">{translation('landing.login')}</div>
            <Form
                name="login"
                autoComplete="off"
                onFinish={onFinish}
            >
                <div className="row d-flex justify-content-center">
                    <Form.Item
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: translation('landing.invalidAccount'),
                            },
                            {
                                validator: (_, value) => {
                                    if (!value) return Promise.resolve();
                                    // Kiểm tra kí tự đặc biệt
                                    if (!/^[a-zA-Z0-9]*$/.test(value)) {
                                        return Promise.reject(translation('landing.usernameInvalidCharacter'));
                                    }
                                    if (value.length < 6) {
                                        return Promise.reject(translation('landing.usernameMinLength'));
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}
                        className="col-12 col-md-6 col-lg-4"
                    >
                        <Input
                            placeholder={translation('landing.account')}
                            type="text"
                            size="large"
                            style={{height:'46px'}}
                        />
                    </Form.Item>
                </div>

                <div className="row d-flex justify-content-center">
                    <Form.Item
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: translation('landing.invalidPassword'),
                            },
                        ]}
                        className="col-12 col-md-6 col-lg-4"
                    >
                        <Input.Password
                            placeholder={translation('landing.password')}
                            size="large"
                            className='style_mobie'
                            style={{height:'46px'}}
                        />
                    </Form.Item>
                </div>
                <div className="row d-flex justify-content-center">
                    <Form.Item className='w-100'>
                        <div className='login_form__wrap col-12 col-md-6 col-lg-4'>
                            <div className='d-flex w-100 justify-content-between align-items-center theme-color-text'>
                                <Typography.Link
                                    onClick={() => history.push("/fogot-password")}
                                >
                                   {translation("landing.fogotPassword")}
                                </Typography.Link>
                                <Button
                                    className="login-btn blue_button"
                                    data-loading-text={translation('landing.processing')}
                                    htmlType="submit"
                                    size="large"
                                >
                                    {translation('landing.login')}
                                </Button>
                            </div>
                        </div>
                    </Form.Item>
                </div>
            </Form>
        </main>
    )
}
export default Login;